module.exports = __webpack_public_path__ + "application/templates/default/inner/movements/inss/list/inss-list.template.html";